import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Marcus Chen',
      role: 'Operations Director, Astronox Festival',
      quote: 'SLUSHd has been our hydration partner for 4 years running. Their vitamin-enriched slushies keep our attendees energized through 12-hour festival days. The health-conscious angle is a huge selling point for our crowd.',
      rating: 5,
    },
    {
      name: 'Jessica Rivera',
      role: 'Event Producer, Symmetry Music Festival',
      quote: 'Finding a beverage vendor that aligns with our wellness-focused brand was tough until we found SLUSHd. No sugar, no junk - just pure refreshment. Our attendees absolutely love them.',
      rating: 5,
    },
    {
      name: 'David Thompson',
      role: 'Vendor Coordinator, Live Nation Events',
      quote: 'We\'ve worked with SLUSHd at multiple large-scale concerts and music festivals. Their high-capacity setup handles massive crowds effortlessly, and the product speaks for itself.',
      rating: 5,
    },
  ];

  return (
    <section 
      id="testimonials" 
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#0a0a0a] noise-bg overflow-hidden"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#CCFF00] text-sm font-medium tracking-widest uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-6xl font-bold tracking-tight uppercase mb-6">
            <span className="text-white">WHAT</span>{' '}
            <span className="text-gradient">THEY SAY</span>
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Don't just take our word for it. Here's what event organizers have to say.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="glass-card rounded-2xl p-8 relative"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-2 text-[#CCFF00]/20">
                <Quote className="w-16 h-16" />
              </div>
              
              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#CCFF00] text-[#CCFF00]" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-white/80 text-lg leading-relaxed mb-8 italic">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="border-t border-white/10 pt-6">
                <div className="font-bold text-white text-lg">
                  {testimonial.name}
                </div>
                <div className="text-[#CCFF00] text-sm uppercase tracking-wider">
                  {testimonial.role}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/2 -translate-y-1/2 -left-32 w-64 h-64 rounded-full bg-[#FF0099]/10 blur-[100px]" />
      <div className="absolute top-1/2 -translate-y-1/2 -right-32 w-64 h-64 rounded-full bg-[#CCFF00]/10 blur-[100px]" />
    </section>
  );
};

export default TestimonialsSection;
